import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCertificationProfessionalRes } from "core/http/service/personnelInformation/resTypes";
import { uniqueId } from "lodash";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: getCertificationProfessionalRes[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getCertificationProfessionalSlice = createSlice({
  name: "getCertificationProfessional",
  initialState,
  reducers: {
    getCertificationProfessionalStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getCertificationProfessionalSuccess: (
      state,
      action: PayloadAction<getCertificationProfessionalRes[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      const certifications = (action.payload ?? []).map((item) => ({
        ...item,
        files: (item.files ?? []).map((file) => ({
          ...file,
          id: uniqueId(),
        })),
      }));
      state.data = certifications;
    },
    getCertificationProfessionalFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetCertificationProfessional: () => {
      return { ...initialState };
    },
  },
});

export const {
  getCertificationProfessionalStart,
  getCertificationProfessionalSuccess,
  getCertificationProfessionalFailed,
  resetCertificationProfessional,
} = getCertificationProfessionalSlice.actions;

export default getCertificationProfessionalSlice.reducer;
